<div class="d-inline">
  <p [class]="titleClass" [class.invalid]="invalid">
    {{ _title }}
    <jhi-bary-icon *ngIf="tooltip" icon="info-circle" [faDirective]="FAS" [mdbTooltip]="tooltip"></jhi-bary-icon>
  </p>
</div>
